import { Row, Col, Form, Input, Button } from "antd";
import { Header } from "../../../components/SecurityCheck/Header";
import { Link, useNavigate } from "react-router-dom";
import { useCallback, FocusEvent } from "react";
import { useAppDispatch } from "../../../store";
import { clearMessage } from "../../../acions/actionsCreators/messageActions";
import { useValidateOnBlur } from "../../../lib/hooks/validateOnBlur";
import ROUTES from "../../../configs/routesConfig";
import { useCredsRules } from "../../../lib/hooks/useCredsRules";

type FirstStepProps = {
  setStep: (value: boolean) => void;
  data: any;
  setData: (value: any) => void;
};

export const FirstStep = ({ setStep, data, setData }: FirstStepProps) => {
  const navigate = useNavigate();

  const [form] = Form.useForm();

  const [validateOnBlur] = useValidateOnBlur(form);

  const dispatch = useAppDispatch();

  const onNextButtonClicked = useCallback(
    (values: any) => {
      setData(values);
      setStep(true);
      dispatch(clearMessage());
    },
    [dispatch, setData, setStep],
  );

  const { usernameRules } = useCredsRules();

  const onBlur = useCallback(
    (e: FocusEvent<HTMLInputElement, Element>) => validateOnBlur(e, "userName"),
    [validateOnBlur],
  );

  const back = useCallback(() => navigate(-1), [navigate]);

  return (
    <Row className="mt-16 justify-center mx-4">
      <Col className="forgot-acc-form">
        <Row className="d-block">
          <Header header="Want to reset your password?" onBackClicked={back} />
          <Row className="mt-2 justify-center">
            <div style={{ width: "280px" }}>
              <p className="my-0 text-center">
                Enter the email address or username you registered with and we
                will help you
              </p>
            </div>
          </Row>
        </Row>
        <Row className="justify-center mt-10 w-100">
          <Col className="forgot-pass">
            <Form
              form={form}
              layout="vertical"
              autoComplete="off"
              requiredMark={false}
              onFinish={onNextButtonClicked}
              initialValues={data}
              className="form__container"
            >
              <Form.Item
                name="userName"
                label="Email or Username"
                className="mb-8"
                rules={usernameRules}
              >
                <Input size="large" onBlur={onBlur} />
              </Form.Item>

              <Form.Item className="mt-3 mb-12">
                <Button
                  type="primary"
                  shape="round"
                  size="large"
                  htmlType="submit"
                  block
                >
                  Next
                </Button>
              </Form.Item>
            </Form>

            <Row className="justify-center links-container">
              <Link className="h-unset pt-0 pl-2" to={ROUTES.FORGOT_ACCOUNT}>
                I forgot email/username
              </Link>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
